<ng-container *ngFor="let error of element.errors;">
  <ng-template [component]="{ name: element.survey.questionErrorComponent, data: { element: element, cssClasses: element.cssClasses, error: error } }"></ng-template>
</ng-container>
